import { useParams, Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import Breadcrumb from '@/components/base/Breadcrumb';
import type { BreadcrumbItem } from '@/components/base/Breadcrumb';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const articleHeroImages: Record<string, string> = {
  '1': 'https://readdy.ai/api/search-image?query=Sweet%20Lolita%20fashion%20beginner%20guide%20with%20pink%20dress%20white%20lace%20stockings%20and%20bows%2C%20cute%20wardrobe%20display%20on%20vanity%20table%2C%20soft%20pastel%20pink%20background%2C%20dreamy%20feminine%20editorial%20photography%20with%20gentle%20natural%20light&width=1600&height=600&seq=article-hero-1&orientation=landscape',
  '2': 'https://readdy.ai/api/search-image?query=Classic%20Lolita%20brand%20collection%20display%20with%20elegant%20Victorian%20style%20dresses%20in%20deep%20burgundy%20and%20navy%2C%20luxurious%20fabric%20close-up%2C%20vintage%20boutique%20interior%20with%20warm%20lighting%2C%20refined%20fashion%20photography&width=1600&height=600&seq=article-hero-2&orientation=landscape',
  '3': 'https://readdy.ai/api/search-image?query=Gothic%20Lolita%20fashion%20with%20black%20lace%20dress%20and%20white%20stockings%2C%20dark%20elegant%20rose%20and%20cross%20motifs%2C%20mysterious%20moonlit%20atmosphere%2C%20dramatic%20cathedral%20window%20background%2C%20dark%20romantic%20editorial%20photography&width=1600&height=600&seq=article-hero-3&orientation=landscape',
  '4': 'https://readdy.ai/api/search-image?query=Chinese%20style%20Lolita%20fashion%20with%20traditional%20silk%20embroidery%20and%20cloud%20shoulder%20design%2C%20elegant%20Eastern%20and%20Western%20fusion%20dress%2C%20warm%20lantern%20light%20background%2C%20soft%20beige%20and%20vermilion%20tones%2C%20cultural%20fusion%20editorial%20photography&width=1600&height=600&seq=article-hero-4&orientation=landscape',
  '5': 'https://readdy.ai/api/search-image?query=Spring%20Lolita%20fashion%20outfit%20with%20cherry%20blossom%20pink%20dress%20and%20white%20lace%20stockings%2C%20pastel%20color%20coordination%2C%20outdoor%20garden%20cherry%20blossom%20background%2C%20soft%20spring%20sunlight%2C%20romantic%20feminine%20editorial%20photography&width=1600&height=600&seq=article-hero-5&orientation=landscape',
  '6': 'https://readdy.ai/api/search-image?query=Elegant%20Lolita%20tea%20party%20with%20beautifully%20set%20table%20with%20vintage%20teacups%20and%20pastries%2C%20participants%20in%20formal%20Lolita%20dresses%2C%20warm%20afternoon%20venue%20with%20floral%20decoration%2C%20sophisticated%20social%20gathering%20photography&width=1600&height=600&seq=article-hero-6&orientation=landscape',
  '7': 'https://readdy.ai/api/search-image?query=White%20lace%20stockings%20and%20Lolita%20fashion%20coordination%2C%20various%20styles%20of%20white%20hosiery%20displayed%20elegantly%2C%20beautiful%20leg%20aesthetics%2C%20soft%20cream%20vanity%20background%2C%20fashion%20accessory%20editorial%20photography%20with%20gentle%20natural%20light&width=1600&height=600&seq=article-hero-7&orientation=landscape',
  '8': 'https://readdy.ai/api/search-image?query=Lolita%20fashion%20beginner%20essential%20items%20checklist%20with%20dress%20petticoat%20blouse%20white%20stockings%20and%20shoes%20laid%20out%20on%20bed%2C%20wardrobe%20planning%20concept%2C%20soft%20pink%20and%20cream%20background%2C%20organized%20fashion%20photography&width=1600&height=600&seq=article-hero-8&orientation=landscape',
  '9': 'https://readdy.ai/api/search-image?query=Chinese%20Lolita%20brand%20showcase%20with%20beautiful%20dresses%20displayed%20on%20mannequins%20in%20boutique%2C%20various%20styles%20from%20sweet%20to%20classic%2C%20modern%20Chinese%20fashion%20retail%20interior%2C%20elegant%20warm%20lighting%2C%20professional%20product%20photography&width=1600&height=600&seq=article-hero-9&orientation=landscape',
  '10': 'https://readdy.ai/api/search-image?query=Winter%20Lolita%20fashion%20with%20warm%20layered%20outfit%2C%20velvet%20dress%20and%20cape%20coat%2C%20white%20velvet%20stockings%2C%20snowy%20outdoor%20scene%20with%20soft%20winter%20light%2C%20cozy%20yet%20elegant%20editorial%20photography&width=1600&height=600&seq=article-hero-10&orientation=landscape',
  '11': 'https://readdy.ai/api/search-image?query=Elegant%20Lolita%20fashion%20dining%20etiquette%20at%20afternoon%20tea%2C%20beautifully%20arranged%20three-tier%20dessert%20stand%2C%20vintage%20teacups%2C%20warm%20tea%20room%20atmosphere%2C%20sophisticated%20social%20dining%20photography&width=1600&height=600&seq=article-hero-11&orientation=landscape',
  '12': 'https://readdy.ai/api/search-image?query=Lolita%20style%20makeup%20look%20with%20porcelain%20skin%20and%20pink%20tones%2C%20beautiful%20eye%20makeup%20close-up%2C%20soft%20vanity%20table%20with%20cosmetics%2C%20delicate%20feminine%20beauty%20editorial%20photography%20with%20gentle%20natural%20light&width=1600&height=600&seq=article-hero-12&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);
  const currentCategory = categories.find((c) => c.slug === article?.category);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
              <i className="ri-file-unknow-line text-2xl text-foreground-500"></i>
            </div>
            <h1 className="text-lg font-heading font-semibold text-foreground-900 mb-2">文章未找到</h1>
            <p className="text-sm text-foreground-600 mb-4">抱歉，您查找的文章不存在或已被移除。</p>
            <Link to="/" className="text-sm text-primary-500 hover:text-primary-600 font-medium">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: '首页', href: '/' },
    ...(currentCategory
      ? [{ label: currentCategory.name, href: `/category/${currentCategory.slug}` }]
      : []),
    { label: article.title },
  ];

  const relatedArticles = articles
    .filter((a) => a.category === article.category && a.id !== article.id)
    .slice(0, 3);

  const heroImage = articleHeroImages[article.id] || articleHeroImages['1'];

  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.publishDate,
    publisher: {
      '@type': 'Organization',
      name: '白丝萝莉',
    },
  };

  return (
    <>
      <Navbar />

      <main>
        {/* Article Hero */}
        <section className="relative w-full h-[280px] md:h-[380px] overflow-hidden mt-16">
          <img
            src={heroImage}
            alt={article.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/15 to-black/35"></div>
        </section>

        {/* Article Content */}
        <article className="py-8 md:py-12 px-4 md:px-6 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <div className="mb-6">
              <Breadcrumb items={breadcrumbItems} />
            </div>

            <h1 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-4 leading-tight">
              {article.title}
            </h1>

            <div className="flex flex-wrap items-center gap-3 md:gap-4 text-sm text-foreground-500 mb-6 pb-6 border-b border-background-200">
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-user-line text-xs"></i>
                </span>
                {article.author}
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-calendar-line text-xs"></i>
                </span>
                {article.publishDate}
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line text-xs"></i>
                </span>
                {article.readTime}阅读
              </span>
              {currentCategory && (
                <Link
                  to={`/category/${currentCategory.slug}`}
                  className="flex items-center gap-1.5 text-primary-500 hover:text-primary-600 transition-colors duration-200"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-folder-line text-xs"></i>
                  </span>
                  {currentCategory.name}
                </Link>
              )}
            </div>

            <div
              className="prose prose-sm md:prose-base max-w-none text-foreground-800 leading-relaxed
                prose-h2:text-lg md:prose-h2:text-xl prose-h2:font-heading prose-h2:font-semibold prose-h2:text-foreground-900 prose-h2:mt-8 prose-h2:mb-4
                prose-p:text-foreground-700 prose-p:leading-relaxed prose-p:mb-4
                prose-strong:text-foreground-900 prose-strong:font-semibold
                [&_p:first-child]:text-base [&_p:first-child]:md:text-lg [&_p:first-child]:text-foreground-800 [&_p:first-child]:leading-relaxed"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />

            <div className="flex flex-wrap gap-1.5 mt-8 pt-6 border-t border-background-200">
              {article.tags.map((tag) => (
                <span
                  key={tag}
                  className="text-xs px-3 py-1 bg-secondary-100 text-secondary-800 rounded-full"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </article>

        {/* Related Articles */}
        {relatedArticles.length > 0 && (
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-6">
                相关文章
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.slug}`}
                    className="group block bg-background-50 border border-background-200/70 rounded-lg p-4 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                  >
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200 font-heading">
                      {ra.title}
                    </h3>
                    <p className="text-xs text-foreground-600 line-clamp-2">{ra.excerpt}</p>
                    <p className="text-xs text-foreground-500 mt-2">{ra.publishDate}</p>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* JSON-LD */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }}
        />

        {/* Breadcrumb JSON-LD */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: breadcrumbItems.map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: item.label,
                item: item.href ? `https://baisiluoli.com${item.href}` : undefined,
              })),
            }),
          }}
        />
      </main>

      <Footer />
    </>
  );
}